import querystring from 'querystring';

const clientId = process.env.SPOTIFY_CLIENT_ID;
const clientSecret = process.env.SPOTIFY_CLIENT_SECRET;
const refreshToken = process.env.SPOTIFY_REFRESH_TOKEN;

const basic = Buffer.from(`${clientId}:${clientSecret}`).toString('base64');
const TOKEN_ENDPOINT = `https://accounts.spotify.com/api/token`;
const NOW_PLAYING_ENDPOINT = `https://api.spotify.com/v1/me/player/currently-playing`;

type SpotifyAccessToken = { access_token: string }
const getAccessToken = (): Promise<SpotifyAccessToken> => {
    return new Promise((resolve, _) => {
        fetch(TOKEN_ENDPOINT, {
            method: 'POST',
            headers: {
                Authorization: `Basic ${basic}`,
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: querystring.stringify({
                grant_type: 'refresh_token',
                scope: 'user-read-currently-playing',
                refresh_token: refreshToken
            })
        })
        .then((response) => {
            response.json().then((data) => {
                return resolve(data)
            })
        })
        .catch((error) => {
            // console.log(error)
        })
    })
} 

const getNowPlaying = async () => {
    const { access_token } = await getAccessToken();
  
    return new Promise((resolve, _) => {
        fetch(NOW_PLAYING_ENDPOINT, {
            headers: {
                Authorization: `Bearer ${access_token}`,
                Accept: 'application/json',
                'Content-Type': 'application/json'
            }
        })
        .then((response) => {
            response.json().then((data) => {
                resolve(data)
            })
            .catch((error) => {
                // onsole.log(error)
            })
        })
    })
};

export { getNowPlaying };